import React from 'react'
import { Col } from 'reactstrap';


export const ComponentDoctors = (props) => {

    const {
        // * INFO DOCTORS
        informationDoctor,
        isRegistration,
        handleSaveDoctor,
        workOrderId,
        handleUpdateDoctor,
        handleDeleteDoctor,
        isEditWorkOrder,
        doctList,
        url_helen,
        cedimi,
        handleCleanDoctor

    } = props;



    return (
        <>
            <Col
                className='p-l-0 p-r-0'
            >
                {
                    informationDoctor.length > 0 && (
                        <div className="pd-body pl-0 pr-0">
                            <div className="doctor-table-header">
                                <span>MÉDICO TRATANTE</span>
                                <span>ESPECIALIDAD</span>
                                <span>CONTACTO</span>
                                <span>IDENTIFICACIÓN</span>
                                <span></span>
                            </div>
                            {
                                // ? LIST DOCTORS
                            }
                            {
                                informationDoctor.map((_doctor) => {

                                    const relatedDoc = doctList.find(doc => doc.id_doctor === _doctor.id_doctor);

                                    return (
                                        <div
                                            key={`doctorId-${_doctor.id_doctor}`}
                                            className="doctor-row"
                                        >

                                            <div className="doc-main">
                                                <div className="doc-avatar">
                                                    <i className="fa fa-user-md"></i>
                                                </div>

                                                <div className="doc-text">
                                                    <div className="doc-name">{_doctor.name}</div>
                                                    <div className="doc-sub">
                                                        <i className="icofont icofont-medal f-14 icon-green"></i>
                                                        {_doctor.code ? "COLEGIADO" : "MÉDICO"}
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="doc-specialty">
                                                <span className="badge-specialty">
                                                    {_doctor.name_specialty || "No registrado"}
                                                </span>
                                            </div>

                                            <div className="doc-contact">

                                                <span className={_doctor.whatsapp_doctor === "N/A" ? "d-none" : ""}  >
                                                    <i className="fa fa-whatsapp icon-green"></i>
                                                    {_doctor.whatsapp_doctor || "No registrado"}
                                                </span>


                                                <span>
                                                    <i className="fa fa-phone icon-green"></i>
                                                    {_doctor.phone || "No registrado"}
                                                </span>


                                                <span>
                                                    <i className="fa fa-envelope icon-green"></i>
                                                    {_doctor.email || "No registrado"}
                                                </span>
                                            </div>

                                            <div className="doc-cedula">
                                                <i className="fa fa-id-card icon-green"></i>

                                                {_doctor.isCommercialPartner && (
                                                    <span>
                                                        <b>No.</b> {_doctor.code || "No registrado"}
                                                    </span>
                                                )}

                                                <span>
                                                    <b>Conv:</b> {_doctor.isCommercialPartner ? "Sí" : "No"}
                                                </span>
                                            </div>

                                            <div className="doc-actions">
                                                {isEditWorkOrder && !_doctor.id_work_order_doctor && (
                                                    <div>
                                                        <button
                                                            className="btn-circle-blue"
                                                            onClick={() => handleSaveDoctor(workOrderId, _doctor.id_doctor)}
                                                        >
                                                            <i className="icofont icofont-save"></i>
                                                        </button>
                                                    </div>
                                                )}


                                                {url_helen !== cedimi && (
                                                    <button
                                                        className="btn-circle-edit"
                                                        onClick={() => handleUpdateDoctor(_doctor.id_doctor)}
                                                    >
                                                        <i className="icofont icofont-ui-edit"></i>
                                                    </button>
                                                )}

                                                {relatedDoc?.id_work_order_doctor && (
                                                    <button
                                                        className="btn-circle-red"
                                                        onClick={() => handleDeleteDoctor(relatedDoc.id_work_order_doctor, _doctor.name)}
                                                    >
                                                        <i className="icofont icofont-ui-delete"></i>
                                                    </button>
                                                )}
                                                {
                                                    !isEditWorkOrder && (
                                                        <button
                                                            className="btn-close-doctor"
                                                            onClick={() => handleCleanDoctor(_doctor.id_doctor)}
                                                        >
                                                            ×
                                                        </button>
                                                    )
                                                }
                                            </div>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    )
                }
                {informationDoctor.length === 0 && (
                    <div className="doc-empty-card">
                        <div className="doc-empty-icon">
                            <i className="fa fa-user-md"></i>
                        </div>
                        <div className="doc-empty-text">
                            <h6>Sin anexo médico</h6>
                            <span>Esta orden no tiene médico asignado</span>
                        </div>
                    </div>
                )}
            </Col >
        </ >
    )
}
